import { createTranslocoScope } from '@gde-mit/angular-core';

export const USER_MANAGEMENT_TRANSLOCO = createTranslocoScope(
  'USER_MANAGEMENT',
  (lang) => import(`./i18n/${lang}.json`),
);

export const USER_MANAGEMENT_I18N_PREFIX = 'USER_MANAGEMENT';
